module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Armless Sofa.c611ac95.jpg";